import { Suspense, useContext, useEffect, useState } from "react";
import { TostMsg } from "../../../App";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import { getAlbum, postCreateAlbum, RenameAlbumName } from "./galleryService";
import { useFormik } from "formik";
import * as Yup from "yup";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import { Link, useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";

const CreateAlbum = () => {
    const [loading, setLoading] = useState(false);
    const { AlbumGUID } = useParams();
    const [albumTypeData, setAlbumTypeData] = useState([]);
    const [AlbumId, setAlbumId] = useState(0)
    let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
    const toster = useContext(TostMsg);
    const history = useHistory();
    useEffect(() => {
        if (AlbumGUID) {
            getAlbumData();
        }
        getAlbumType();
    }, [])

    async function getAlbumData() {
        setLoading(true);
        const param = {
            AlbumId: 0,
            EmpId:  0, // userDetails?.EmpId,
            AlbumTypeId: 0,
            GUID: AlbumGUID
        };
        try {
            const response = await getAlbum(param);
            let AlbumResponce = response?.Data[0];
            setAlbumId(AlbumResponce?.Id)
            const AlbumValues = {
                albumName: AlbumResponce.Name,
                discription: AlbumResponce.Description,
                albumTypeId: AlbumResponce.AlbumTypeId,
            }
            createAlbumForm.setValues(AlbumValues);
            setLoading(false);
        } catch (error) {
            toster.current.error(ERROR_LIST.GalleryGetAlbum)
            setLoading(false);
        }
    }

    const createAlbumValidation = Yup.object().shape({
        albumName: Yup.string().required("Album name is required"),
        discription: Yup.string().required("Description is required"),
        albumTypeId: Yup.string(),
    });
    const createAlbumForm = useFormik({
        initialValues: {
            albumName: "",
            discription: "",
            albumTypeId: "",
        },
        validationSchema: createAlbumValidation,
        onSubmit: async (data) => {
            setLoading(true);
            if (AlbumGUID) {
                const body = {
                    ModifiedById: userDetails?.EmpId,
                    AlbumId: Number(AlbumId),
                    Name: data?.albumName,
                    Desc: data?.discription,
                };
                try {
                    await RenameAlbumName(body);
                    setLoading(false)
                    history.push(`/Gallery`);
                    toster.current.success('Album updated successfully');
                } catch (err) {
                    setLoading(false)
                    toster.current.error(ERROR_LIST.GalleryAddAlbum)
                }
            } else {
                const body = {
                    Id: 0,
                    EmpId: 0,
                    Name: data?.albumName,
                    Desc: data?.discription,
                };
                try {
                    await postCreateAlbum(body);
                    setLoading(false)
                    history.push(`/Gallery`);
                    toster.current.success('Album added successfully');
                } catch (err) {
                    setLoading(false)
                    toster.current.error(ERROR_LIST.GalleryAddAlbum)
                }
            }

        },
    });

    async function getAlbumType() {
        setLoading(true);
        const param = {
            masterType: "albumtype",
            organisationId: userDetails?.OrgId,
        };
        try {
            const response = await GetMasterTypeData(param);
            let newAlbumList = response?.Data?.toSpliced(0, 0, {
                Id: "0",
                Name: 'All Album'
            });
            setAlbumTypeData(newAlbumList);
            setLoading(false);
        } catch (error) {
            setLoading(false);
      toster.current.error(ERROR_LIST?.MasterDataType);

        }
    }

    function RecetcreateAlbumForm() {
        createAlbumForm.resetForm();
        history.push(`/Gallery`);
    }

    return (
        <> <div id="circular-menu" className="circular-menu position-relation">
            <div className="items-wrapper">
                <div className="menu-item is-flex">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-bell"
                    >
                        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                        <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                    </svg>
                </div>
                <Link
                    className="menu-item is-flex right-panel-trigger"
                    data-panel="languages-panel"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-bell"
                    >
                        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                        <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                    </svg>
                </Link>
                <Link href="" className="menu-item is-flex">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-bell"
                    >
                        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                        <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                    </svg>
                </Link>
                <Link
                    className="menu-item is-flex right-panel-trigger"
                    data-panel="activity-panel"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-grid"
                    >
                        <rect x="3" y="3" width="7" height="7"></rect>
                        <rect x="14" y="3" width="7" height="7"></rect>
                        <rect x="14" y="14" width="7" height="7"></rect>
                        <rect x="3" y="14" width="7" height="7"></rect>
                    </svg>
                </Link>
            </div>
        </div>

            <div className="container-fluid  position-relation">
                <div className="row">
                    <div className="edit-ticket mb-4">
                        <div className="w-100">
                            <div className="row">
                                <div className="col-md-9 shrink-w">
                                    <div className="form-head d-flex flex-wrap align-items-center mb-4">
                                        <div className="me-auto">
                                            {AlbumGUID ? (
                                                <h2 className="font-w600 mb-0">Edit Album</h2>
                                            ) : (
                                                <h2 className="font-w600 mb-0"> New Album</h2>
                                            )}
</div>
                                        <div className="rightside-tabs">
                                            <Link to="/Gallery">
                                                <button className="back-newticket w-auto float-right">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="25"
                                                        height="25"
                                                        fill="currentColor"
                                                        className="bi bi-arrow-left-short"
                                                        viewBox="0 0
   16 16"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            d="M12 8a.5.5 0 0 1-.5.5H5.7
   07l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5
   .5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                                                        ></path>
                                                    </svg>{" "}
                                                    Back
                                                </button>
                                            </Link>
                                        </div>
                                    </div>
                                    <form onSubmit={createAlbumForm.handleSubmit} className="card">
                                        <div className="row justify-content-center gaprow">
                                            <div className="col-xl-9">
                                                <div className="employee-card tile-grid tile-grid-v1">
                                                    <div id="feed-post-1" className="AnnouncementForm">
                                                        <div className="third-section">
                                                            <div className="row">
                                                                <div className="mb-4 col-md-12">
                                                                    <label className="form-label">Album Name</label>
                                                                    <div className="cover-form">
                                                                        <i
                                                                            className="fa fa-sticky-note-o"
                                                                            aria-hidden="true"
                                                                        ></i>
                                                                        <textarea
                                                                            rows="2"
                                                                            cols="1"
                                                                            name="albumName"
                                                                            className={
                                                                                "form-control" +
                                                                                (createAlbumForm.errors.albumName &&
                                                                                    createAlbumForm.touched.albumName
                                                                                    ? " is-invalid"
                                                                                    : "")
                                                                            }
                                                                            onChange={createAlbumForm.handleChange}
                                                                            value={createAlbumForm.values.albumName}
                                                                            placeholder="Album Name"
                                                                        ></textarea>
                                                                    </div>
                                                                    <div className="invalid-feedback">
                                                                        {createAlbumForm.errors.albumName &&
                                                                            createAlbumForm.touched.albumName
                                                                            ? createAlbumForm.errors.albumName
                                                                            : null}
                                                                    </div>
                                                                </div>
                                                                <div className="mb-4 col-md-12"> <label className="form-label">
                                                                    Description
                                                                </label>
                                                                    <div className="cover-form">
                                                                    <i
                                                                            className="fa fa-sticky-note-o"
                                                                            aria-hidden="true"
                                                                        ></i>
                                                                        <textarea
                                                                            rows="8"
                                                                            cols="8"
                                                                            name="discription"
                                                                            className={
                                                                                "form-control" +
                                                                                (createAlbumForm.errors.discription &&
                                                                                    createAlbumForm.touched.discription
                                                                                    ? " is-invalid"
                                                                                    : "")
                                                                            }
                                                                            onChange={createAlbumForm.handleChange}
                                                                            value={createAlbumForm.values.discription}
                                                                            placeholder="Description"
                                                                        ></textarea>
                                                                    </div>
                                                                    <div className="invalid-feedback">
                                                                        {createAlbumForm.errors.discription &&
                                                                            createAlbumForm.touched.discription
                                                                            ? createAlbumForm.errors.discription
                                                                            : null}
                                                                    </div>
                                                                </div>         </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="btns-grp">
                                                    <button
                                                        type="submit"
                                                        className="cancelbtn-click"
                                                        fdprocessedid="5mw059"
                                                        onClick={RecetcreateAlbumForm}>
                                                        Cancel
                                                    </button>
                                                    {AlbumGUID ? (
                                                        <button
                                                            type="submit"
                                                            className="savebtn-click"
                                                            fdprocessedid="jjj57m"
                                                        >
                                                            Update
                                                        </button>
                                                    ) : (
                                                        <button
                                                            type="submit"
                                                            className="savebtn-click"
                                                            fdprocessedid="jjj57m"
                                                        >
                                                            Save
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {loading ? (
                    <Suspense>
                        <ComponentLoader />
                    </Suspense>
                ) : (
                    ""
                )}
            </div>
        </>
    )
}
export default CreateAlbum;